import React, { useState, useEffect } from 'react';
import {
  Button,
  Modal,
  Form,
  Input,
  Select,
  message,
  Typography,
  Row,
  Col,
  Tag,
  Empty,
  Spin,
} from 'antd';
import {
  PlusOutlined,
  QuestionCircleOutlined,
} from '@ant-design/icons';
import { perguntasAPI } from '../services/api';
import ItemCard from '../components/ItemCard';

const { Title } = Typography;
const { TextArea } = Input;
const { Option } = Select;

const PerguntasPage = () => {
  const [perguntas, setPerguntas] = useState([]);
  const [loading, setLoading] = useState(false);
  const [modalVisible, setModalVisible] = useState(false);
  const [editingPergunta, setEditingPergunta] = useState(null);
  const [filtro, setFiltro] = useState('');
  const [form] = Form.useForm();

  useEffect(() => {
    loadPerguntas();
  }, [filtro]);

  const loadPerguntas = async () => {
    setLoading(true);
    try {
      const response = await perguntasAPI.getAll(filtro);
      setPerguntas(response.data);
    } catch (error) {
      message.error('Erro ao carregar perguntas');
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  const handleAdd = () => {
    setEditingPergunta(null);
    form.resetFields();
    setModalVisible(true);
  };

  const handleEdit = (pergunta) => {
    setEditingPergunta(pergunta);
    form.setFieldsValue(pergunta);
    setModalVisible(true);
  };

  const handleDelete = async (id) => {
    try {
      await perguntasAPI.delete(id);
      message.success('Pergunta deletada com sucesso');
      loadPerguntas();
    } catch (error) {
      message.error('Erro ao deletar pergunta');
      console.error(error);
    }
  };

  const handleSubmit = async (values) => {
    try {
      if (editingPergunta) {
        await perguntasAPI.update(editingPergunta._id, values);
        message.success('Pergunta atualizada com sucesso');
      } else {
        await perguntasAPI.create(values);
        message.success('Pergunta criada com sucesso');
      }
      setModalVisible(false);
      loadPerguntas();
    } catch (error) {
      message.error('Erro ao salvar pergunta');
      console.error(error);
    }
  };
  const renderPerguntaContent = (pergunta) => {
    return (
      <div className="card-text">
        <strong>Resposta:</strong> {pergunta.resposta}
      </div>
    );
  };

  const renderPerguntaMeta = (pergunta) => {
    return (
      <Tag color={pergunta.produto === 'CSAP' ? 'blue' : 'green'}>
        {pergunta.produto}
      </Tag>
    );
  };
  return (
    <div className="admin-page-container">      <div className="filter-section">
        <Row style={{ width: '100%' }} justify="space-between" align="middle">
          <Col>
            <Button type="primary" icon={<PlusOutlined />} onClick={handleAdd}>
              Nova Pergunta
            </Button>
          </Col>
          <Col>
            <Select
              placeholder="Filtrar por produto"
              style={{ width: 200 }}
              value={filtro}
              onChange={setFiltro}
              allowClear
            >
              <Option value="CSAP">CSAP</Option>
              <Option value="RHA">RHA</Option>
            </Select>
          </Col>
        </Row>
      </div><Spin spinning={loading}>
        {perguntas.length === 0 ? (
          <Empty 
            description="Nenhuma pergunta encontrada"
            image={Empty.PRESENTED_IMAGE_SIMPLE}
          />
        ) : (
          <div className="cards-container">
            {perguntas.map(pergunta => (
              <ItemCard
                key={pergunta._id}
                item={pergunta}
                onEdit={handleEdit}
                onDelete={handleDelete}
                renderContent={renderPerguntaContent}
                renderMeta={renderPerguntaMeta}
                showLink={false}
              />
            ))}
          </div>
        )}
      </Spin>

      <Modal
        title={editingPergunta ? 'Editar Pergunta' : 'Nova Pergunta'}
        open={modalVisible}
        onCancel={() => setModalVisible(false)}
        onOk={() => form.submit()}
        width={800}
        okText="Salvar"
        cancelText="Cancelar"
      >
        <Form
          form={form}
          layout="vertical"
          onFinish={handleSubmit}
          className="modal-form"
        >
          <Form.Item
            name="pergunta"
            label="Pergunta"
            rules={[{ required: true, message: 'Digite a pergunta' }]}
          >
            <TextArea rows={3} placeholder="Pergunta frequente" />
          </Form.Item>

          <Form.Item
            name="resposta"
            label="Resposta"
            rules={[{ required: true, message: 'Digite a resposta' }]}
          >
            <TextArea rows={4} placeholder="Resposta para a pergunta" />
          </Form.Item>

          <Form.Item
            name="produto"
            label="Produto"
            rules={[{ required: true, message: 'Selecione o produto' }]}
          >
            <Select placeholder="Selecione o produto">
              <Option value="CSAP">CSAP - Cuidados Saúde Atenção Primária</Option>
              <Option value="RHA">RHA - Reprodução Humana Assistida</Option>
            </Select>
          </Form.Item>
        </Form>
      </Modal>
    </div>
  );
};

export default PerguntasPage;
